import { useQueryClient as y, useMutation as l, useQuery as N } from "@tanstack/react-query";
import c from "./user-notes.api.js";
import { teachurKeys as t } from "../../constants/teachurKeys.js";
const F = (e) => N({
  queryKey: t.userNotes.forObjective(e),
  queryFn: async () => (await c.getAllForObjective(e)).data,
  enabled: e > 0,
  staleTime: 0
}), Q = (e) => N({
  queryKey: t.userNotes.forLesson(e),
  queryFn: async () => (await c.getAllForLesson(e)).data,
  enabled: e > 0,
  staleTime: 0
}), d = (e) => N({
  queryKey: t.userNotes.forCourse(e),
  queryFn: async () => (await c.getAllForCourse(e)).data,
  enabled: e > 0,
  staleTime: 0
}), C = (e) => {
  const s = y();
  return l(
    async (r) => (await c.create(r)).data,
    {
      ...e,
      onSuccess: (r, u, n) => {
        var a;
        s.invalidateQueries({ queryKey: t.userNotes.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, n);
      }
    }
  );
}, K = (e) => {
  const s = y();
  return l(
    async ({ id: r, data: u }) => (await c.update(r, u)).data,
    {
      ...e,
      onSuccess: (r, u, n) => {
        var a;
        s.invalidateQueries({ queryKey: t.userNotes.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, n);
      }
    }
  );
}, w = (e) => {
  const s = y();
  return l(
    async (r) => (await c.remove(r)).data,
    {
      ...e,
      onMutate: async () => {
        await s.cancelQueries({ queryKey: t.userNotes.all });
      },
      onSuccess: (r, u, n) => {
        var a;
        s.invalidateQueries({ queryKey: t.userNotes.all }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u, n);
      },
      onError: e == null ? void 0 : e.onError
    }
  );
};
export {
  C as useCreateUserNoteMutation,
  w as useDeleteUserNoteMutation,
  d as useGetUserNotesForCourseQuery,
  Q as useGetUserNotesForLessonQuery,
  F as useGetUserNotesForObjectiveQuery,
  K as useUpdateUserNoteMutation
};
